import { Header } from '@profitowi/component-library';
import { Route, Routes } from 'react-router-dom';

import NavigationToolbar from '../../components/NavigationToolbar/NavigationToolbar';
// Hide blockades tab for now @PROFMP140-3
//import Blockades from './Blockades/Blockades';
import CreateSettlementModal from './CreateSettlementModal';
import Files from './Files';
import List from './List';
import Settlement from './Settlement';
import SettlementConfirmationModal from './SettlementConfirmationModal/SettlementConfirmationModal';

const Settlements = () => (
  <>
    <Header as="h1" size="xl" weight="semibold">
      Rozliczenia
    </Header>

    <NavigationToolbar
      rootPath="/settlements"
      tabs={[
        { displayName: 'Rozliczenia', route: '/' },
        { displayName: 'Pliki', route: 'files' },
        // Hide blockades tab for now @PROFMP140-3
        // { displayName: 'Blokady', route: 'blockades' },
      ]}
    />

    <Routes>
      <Route path="/" element={<List />}>
        <Route path="create" element={<CreateSettlementModal />} />
        <Route path="settlementConfirmation" element={<SettlementConfirmationModal />} />
      </Route>
      <Route path="/:settlementId/*" element={<Settlement />} />
      <Route path="files/*" element={<Files />} />
      {/* {/* Hide blockades tab for now @PROFMP140-3 */}
      {/* <Route path="blockades/*" element={<Blockades />} /> */}
    </Routes>
  </>
);

export default Settlements;
